import { Skeleton } from '@mui/material';

const SidebarSkeleton = ({ width = "60%" }) => {
    return <div style={{ display: 'flex', gap: '12px', padding: '10px 5px', marginBottom: '4px' }}>
        <Skeleton
            variant="circular"
            width={40}
            height={40}
            animation="wave"
        />
        <Skeleton
            variant="text"
            sx={{ fontSize: '12px' }}
            width={width}
            animation="wave"
        />
    </div>;
};

export default SidebarSkeleton;